import React, { useState, useEffect } from "react";
import style from "../../style/HistoryListBody.module.scss";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import PenToSquareRegular from "../Icon/PenToSquareRegular";
import HospitalUnlockKeyholeRegular from "../Icon/HospitalUnlockKeyholeRegular";
import HospitalLockRegular from "../Icon/HospitalLockRegular";
import Sort from "../Icon/Sort";
import SortAsc from "../Icon/SortAsc";
import SortDesc from "../Icon/SortDesc";
import BellSlashRegular from "../Icon/BellSlashRegular";
import dayjs from "dayjs";
import Logger from "../../libraries/Logger";

function HospitalManageListBody({ data, column, direction, onSort }) {
  const [Column, setColumn] = useState("");
  const [Direction, setDirection] = useState("");
  useEffect(() => {
    setColumn(column);
    setDirection(direction);
  }, []);

  const [isOtherHospital, setIsOtherHospital] = useState(null);
  useEffect(() => {
    setIsOtherHospital(
      JSON.parse(localStorage.getItem("auth"))?.IsOtherHospital
    );
  }, [isOtherHospital]);

  useEffect(() => {
    setIsOtherHospital(
      JSON.parse(localStorage.getItem("auth"))?.IsOtherHospital
    );
  }, [isOtherHospital]);

  const handleSortChange = (column, direction) => {
    // console.log("ListBodyhandleSortChange");
    setColumn(column);
    setDirection(direction);
    onSort(column, direction);
  };

  return (
    <Table className={style.table}>
      <Thead>
        <Tr className={style.table_title}>
          <Th className={style.table_title_self}>序號</Th>
          <Th className={style.table_title_self}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              機構代碼
              {Column == "Code" ? (
                Direction == "asc" ? (
                  <SortAsc
                    data={"Code"}
                    Column={Column}
                    Direction={Direction}
                    onSort={handleSortChange}
                  />
                ) : (
                  <SortDesc
                    data={"Code"}
                    Column={Column}
                    Direction={Direction}
                    onSort={handleSortChange}
                  />
                )
              ) : (
                <Sort
                  data={"Code"}
                  Column={Column}
                  Direction={Direction}
                  onSort={handleSortChange}
                />
              )}
            </div>
          </Th>
          <Th className={style.table_title_self}>機構中文名稱</Th>
          <Th className={style.table_title_self}>機構英文名稱</Th>
          <Th className={style.table_title_self}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              選單顯示名稱
              {Column == "Prefix" ? (
                Direction == "asc" ? (
                  <SortAsc
                    data={"Prefix"}
                    Column={Column}
                    Direction={Direction}
                    onSort={handleSortChange}
                  />
                ) : (
                  <SortDesc
                    data={"Prefix"}
                    Column={Column}
                    Direction={Direction}
                    onSort={handleSortChange}
                  />
                )
              ) : (
                <Sort
                  data={"Prefix"}
                  Column={Column}
                  Direction={Direction}
                  onSort={handleSortChange}
                />
              )}
            </div>
          </Th>
          <Th className={style.table_title_self}>狀態</Th>
          <Th className={style.table_title_self}>編輯</Th>
        </Tr>
      </Thead>
      <Tbody>
        {data?.HospitalData?.map((v, i) => {
          return (
            <Tr key={i} className={style.table_body}>
              <Td className={style.table_body_self}> {i + 1} </Td>
              <Td className={style.table_body_self}>{v.OrgCode}</Td>
              <Td className={style.table_body_self}>{v.OrgName}</Td>
              <Td className={style.table_body_self}>{v.OrgEngName}</Td>
              <Td className={style.table_body_self}>{v.OrgPrefix}</Td>
              <Td className={style.table_body_self}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  {v.Status === 1 ? "啟用" : ""}
                  {v.Status === 2 ? "停用" : ""}
                  {v.Status === 1 ? (
                    <p
                      style={{
                        padding: "1px 1px 1px 5px",
                        alignItems: "center",
                      }}
                    >
                      <HospitalLockRegular RowId={v.RowId} Status={2} />
                    </p>
                  ) : (
                    ""
                  )}
                  {v.Status === 2 ? (
                    <p
                      style={{
                        padding: "1px 1px 1px 5px",
                        alignItems: "center",
                      }}
                    >
                      <HospitalUnlockKeyholeRegular
                        RowId={v.RowId}
                        Status={1}
                      />
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </Td>
              <Td className={style.table_body_self}>
                {
                  <PenToSquareRegular
                    navigatePath={`/HospitalEdit?rowId=${v.RowId}`}
                  />
                }
              </Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
}

export default HospitalManageListBody;
